import DefaultLayout from '@/modules/Signup/layouts/DefaultLayout.vue';
import SignUpForm from '@/modules/Signup/views/sign-up-form/SignUpForm.vue';
import PlansAndPricing from '@/modules/Signup/views/plans-and-pricing/PlansAndPricing.vue';
import SiteContactDetailsIndex from '@/modules/Signup/views/site-contact-details/MainForm.vue';
import ErrorView from '@/modules/Signup/views/ErrorView.vue';

export default [
    {
        path: '/signup',
        component: DefaultLayout,
        redirect: { name: 'plans-and-pricing' },
        meta : {
            title : "Ezi Broadband Plans"
        },
        children: [
            {
                path: 'form',
                name: 'signup',
                component: SignUpForm,
                title: 'Ezi Broadband Plans',
            },
            {
                path: 'plans-and-pricing',
                name: 'plans-and-pricing',
                component: PlansAndPricing,
                title: 'Ezi Broadband Plans',
            },
            {
                path: 'site-contact-details',
                name: 'site-contact-details',
                component: SiteContactDetailsIndex,
                title: 'Ezi Broadband Plans',
            },
            {
                path: 'error',
                name: 'error',
                component: ErrorView,
                title: 'Ezi Broadband Plans',
            },
        ],
    },
];
